/* MALA — mobile drawer drill-down for 2-level menus
 *
 * Horizon's native slide-panel UX only activates for 3-level menus. For 2-level
 * menus (Hijab → All Hijabs / One Minute Hijab / ..., no third level) Horizon
 * renders a flat list where childlists are visible alongside parents — which
 * is what users see as "sab sub-items automatically show ho rahe".
 *
 * This script converts that flat structure into Hijab-Company-style drill-down:
 *   - childlists are hidden by CSS by default
 *   - tapping a parent mainlist <a> with a childlist sibling slides into that
 *     sub-collection only, hiding all top-level siblings
 *   - a "← Back" button appears at the top with the parent's title
 *   - tapping back exits drill state
 *   - closing the drawer always resets drill state
 *
 * Mobile only (< 750px). Desktop nav untouched.
 */
(function () {
  if (window.__mala_drawer_drill_v2) return;
  window.__mala_drawer_drill_v2 = true;

  var MOBILE_MAX = 749;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
  }

  function getDirectChildlist(li) {
    if (!li) return null;
    var children = li.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].classList && children[i].classList.contains('menu-drawer__menu--childlist')) {
        return children[i];
      }
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (e) {
      // Back button click — handle first so it works even if other handlers fire
      var back = e.target.closest('.mala-drawer-back');
      if (back) {
        e.preventDefault();
        e.stopPropagation();
        drillOut(back.closest('.menu-drawer'));
        return;
      }

      // Drawer close button or hamburger toggle — reset drill state
      var closer = e.target.closest('.menu-drawer__close-button, header-drawer > details > summary');
      if (closer) {
        setTimeout(function () {
          document.querySelectorAll('.menu-drawer.mala-drill-active').forEach(drillOut);
        }, 80);
        return;
      }

      // Parent mainlist click — only in flat 2-level mode
      if (!isMobile()) return;

      var link = e.target.closest('.menu-drawer .menu-drawer__menu-item--mainlist');
      if (!link) return;

      // Skip summaries (handled natively by Horizon for 3-level menus or accordion mode)
      if (link.tagName !== 'A') return;

      var li = link.closest('li');
      if (!li) return;

      var childlist = getDirectChildlist(li);
      if (!childlist) return;

      e.preventDefault();
      e.stopPropagation();

      var drawer = link.closest('.menu-drawer');
      if (!drawer) return;

      drillTo(drawer, li, link.textContent.trim());
    },
    false
  );

  function drillTo(drawer, li, title) {
    drawer.querySelectorAll('.mala-drill-current').forEach(function (el) {
      el.classList.remove('mala-drill-current');
    });
    li.classList.add('mala-drill-current');
    drawer.classList.add('mala-drill-active');
    ensureBackButton(drawer, title);

    // Scroll to top of the panel
    var scroller =
      drawer.querySelector('.menu-drawer__navigation-container') ||
      drawer.querySelector('.menu-drawer__navigation') ||
      drawer;
    scroller.scrollTop = 0;
  }

  function drillOut(drawer) {
    if (!drawer) return;
    drawer.classList.remove('mala-drill-active');
    drawer.querySelectorAll('.mala-drill-current').forEach(function (el) {
      el.classList.remove('mala-drill-current');
    });
    var back = drawer.querySelector('.mala-drawer-back');
    if (back) back.remove();
  }

  function ensureBackButton(drawer, title) {
    var back = drawer.querySelector('.mala-drawer-back');
    if (!back) {
      back = document.createElement('button');
      back.type = 'button';
      back.className = 'mala-drawer-back';
      back.setAttribute('aria-label', 'Back');
      back.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M15 6l-6 6 6 6"/></svg>' +
        '<span class="mala-drawer-back__label"></span>';
      var container =
        drawer.querySelector('.menu-drawer__navigation-container') ||
        drawer.querySelector('.menu-drawer__navigation') ||
        drawer.querySelector('.menu-drawer__inner-container') ||
        drawer;
      container.insertBefore(back, container.firstChild);
    }
    var label = back.querySelector('.mala-drawer-back__label');
    if (label) label.textContent = title || 'Back';
  }

  window.addEventListener('resize', function () {
    if (!isMobile()) {
      document.querySelectorAll('.menu-drawer.mala-drill-active').forEach(drillOut);
    }
  });
})();
